import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import {
  Box,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import Grow from '@mui/material/Grow';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import {
  createUserOrUpdateUser,
  getUserSubmitions,
  verifyUserOTP,
} from '../../features/user/user.slice';

import Zoom from '@mui/material/Zoom';
import moment from 'moment';
import { resetData, updateData } from '../../features/data/data.slice';
import {
  changeStep,
  completeFormStep,
  updateFormStepperSteps,
} from '../../features/formStepper.slice';
import { completeStep, setRequireHelp, updateStep } from '../../features/stepper.slice';
import {
  resetSubmition,
  saveSubmition,
  updateSubmition,
} from '../../features/submition/submition.slice';
import PrimaryButton from '../ui/buttons/primaryButton';
import Form from '../ui/forms';
import Input from '../ui/forms/fields/input';
import { resetFiles } from '../../features/fileUpload/fileUpload.slice';
import { useGA4React } from 'ga-4-react';
import { Report } from '../../libs/loggers';

const useStyles = makeStyles((theme) => ({
  dialog: {
    minHeight: '250px',
    background: theme.palette.mode === 'light' ? '#fff' : '#373434',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  listItem: {
    background: theme.palette.mode === 'light' ? '#EAE8E4' : '#2E2A2B',
    paddingRight: '16px',
    paddingLeft: '16px',
    marginBottom: '16px',
    overflow: 'hidden',
  },
  continueButton: {
    borderRadius: '10px',
  },

  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
  vehicleName: {
    width: '100px',
  },
  textButton: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',

    marginBottom: '16px',
    cursor: 'pointer',
    textAlign: 'center',
    width: '75%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: '5px',
      paddingLeft: '5px',
    },
    background: theme.palette.mode === 'light' ? '#000000' : '#FFFFFF',
    color: theme.palette.mode === 'light' ? '#FFFFFF' : '#000000',
  },
  tick: {
    color: '#d59066',
    marginTop: '20px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '150px',
    },
    height: 'auto',
    margin: 'auto',
  },
  title: {
    marginTop: '30px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  projectListTitle: {
    marginTop: '35px',
    marginBottom: '30px',
    textAlign: 'center',
  },
  otptitle: {
    marginTop: '20px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  backDrop: {
    backdropFilter: 'blur(5px)',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
}));

export default function RecallApplicationDialog(props) {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const ga4 = useGA4React();

  const logEvent = (action, label, category) => {
    ga4.event(action, label, category);
  };

  const loading = useSelector((state) => state.user.user.loading);
  const submitions = useSelector((state) => state.user.submitions);
  const userId = useSelector((state) => state.user.user.userId);
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);
  const [verified, setVerified] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const validationSchema = yup.object().shape({
    email: yup.string(),
    otp: yup.string(),
  });
  const stepperSteps = useSelector((state) => state.stepper.value.steps);
  const stepper = useSelector((state) => state.stepper.value);
  const investVehicles = useSelector((state) => state.investVehicle.value.vehicles);
  const formStepperSteps = useSelector((state) => state.formStepper.value.formSectionsSteps);
  const submitionId = useSelector((state) => state.submition.submition?.submitionId);
  const [selectedSubmition, setSelectedSubmition] = useState({});
  const {
    watch,
    setValue,
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(validationSchema),
  });

  const otp = watch('otp');
  let page = window.location.pathname.replace(/^\/|\/$/g, '');
  useEffect(() => {
    let countdown = null;
    if (seconds > 0) {
      countdown = setInterval(() => setSeconds(seconds - 1), 1000);
    } else {
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [seconds]);

  useEffect(() => {
    register('userId');
    setValue('userId', userId);
  }, [otp]);

  useEffect(() => {
    if (submitions && submitions.length <= 0) {
      reset();
    }
  }, [submitions]);

  useEffect(() => {
    const vehicleIndex = investVehicles.findIndex((object) => {
      return object.name === selectedSubmition.vehicle;
    });
    const choseVehicle = investVehicles[vehicleIndex];
    if (choseVehicle) {
      dispatch(updateFormStepperSteps(choseVehicle.formSections));
    }
  }, [selectedSubmition]);

  const handleOpen = () => {
    logEvent('click', 'recall_application', `application`);
    const eventInfo = {
      action: 'click',
      category: 'application-recall',
      description: 'Continue with existing application',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'recall',
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpen(true);
  };

  const handleBack = () => {
    setVerified(false);
    setShowOtp(false);
    reset();
  };
  const handleClose = () => {
    logEvent('close', 'recall_application_popup', `applications`);
    setOpen(false);
  };

  const handleChange = () => {
    setDeleteConfirmation((prev) => !prev);
  };

  const selectSubmition = (submition) => {
    const eventInfo = {
      action: 'select',
      category: 'application-recall',
      description: 'Select application',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'select_application',
      },
    };
    Report(eventInfo, userId, submitionId);
    setDeleteConfirmation(false);
    setSelectedSubmition(submition);
  };

  const onEmailSubmit = async (props) => {
    logEvent('submit', 'recall_application', `email`);
    const eventInfo = {
      action: props.resend ? 'click' : 'submit',
      category: 'application-recall',
      description: props.resend ? 'Clicked resend otp in continue' : 'Submit email in continue',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: props.resend ? 'resend_otp' : 'submit_emial',
      },
    };
    Report(eventInfo, userId, submitionId);
    const data = await getValues();
    await dispatch(createUserOrUpdateUser(data))
      .unwrap()
      .then((res) => {
        setVerified(false);
        setShowOtp(true);
        setSeconds(60);
      });
  };

  const onOTPSubmit = async () => {
    logEvent('verify', 'recall_application', `otp`);
    const eventInfo = {
      action: 'submit',
      category: 'application-recall',
      description: 'Submit email in continue',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'submit_otp',
      },
    };
    Report(eventInfo, userId, submitionId);
    const data = await getValues();
    await dispatch(verifyUserOTP(data))
      .unwrap()
      .then(async (res) => {
        await dispatch(getUserSubmitions(data.userId))
          .unwrap()
          .then((res) => {});
        setVerified(res.success);
      });
  };

  const deleteSubmision = async (submition) => {
    logEvent('delete', 'delete_application', `Delete-Application-${submition.vehicle}`);

    const eventInfo = {
      action: 'delete',
      category: 'application-recall',
      description: 'delete application',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'delete_application',
      },
    };
    Report(eventInfo, userId, submitionId);

    try {
      await dispatch(
        updateSubmition({
          ...submition,
          deleted: true,
          submitionId: submition._id,
        })
      )
        .unwrap()
        .then(async (originalPromiseResult) => {
          await dispatch(getUserSubmitions(getValues('userId')))
            .unwrap()
            .then((res) => {
              if (res.data.length <= 0) {
                setValue('email', '');
              }
            });

          setSelectedSubmition({});
          dispatch(resetSubmition());
          dispatch(resetData());
          dispatch(resetFiles());
        })
        .catch(() => {});
    } catch (error) {
      console.log(error);
    }
  };

  const continueWithApplication = (application) => {
    console.log('application', application);
    const vehicleIndex = investVehicles.findIndex((object) => {
      return object.name === application.vehicle;
    });
    const choseVehicle = investVehicles[vehicleIndex];

    const eventInfo = {
      action: 'click',
      category: 'application-recall',
      description: 'continue with application',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'continue_application',
      },
    };
    Report(eventInfo, userId, submitionId);

    dispatch(
      saveSubmition({
        ...application,
      })
    );
    dispatch(
      updateData({
        funds: application.funds,
        vehicle: application.vehicle,
        ...application.requireHelp,
        ...application.helpDialog,
      })
    );
    dispatch(setRequireHelp(application.requireHelp));
    dispatch(updateFormStepperSteps(choseVehicle.formSections));
    dispatch(updateStep(application.activeStepperStep));
    dispatch(changeStep(application.activeFormStep));
    navigate(stepperSteps[application.activeStepperStep].url);

    stepperSteps.forEach((element, index) => {
      if (index < application.activeStepperStep) {
        dispatch(completeStep(index));
      }
      return;
    });

    formStepperSteps.forEach((element, index) => {
      if (index <= application.activeFormStep) {
        dispatch(completeFormStep(element.slug));
      }
      return;
    });
  };

  const userEmail = () => {
    return (
      <>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="h4" className={classes.title}>
            Please provide us with a email address you <br /> used to save your existing
            application.
          </Typography>
          <Form>
            <Input {...register('email')} fullWidth label="Email" variant="outlined" />
          </Form>
          <Box display={'flex'} justifyContent={'center'} marginTop="20px">
            <PrimaryButton
              size={'large'}
              disabled={loading}
              className={classes.continueButton}
              onClick={() => onEmailSubmit({ resend: false })}
              sx={{
                '&.Mui-disabled': {
                  background: '#CC6323',
                  color: '#fff',
                },
              }}
            >
              {'Submit'}
              {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
            </PrimaryButton>
          </Box>
        </DialogContent>
      </>
    );
  };

  const userOTP = () => {
    let time;
    seconds > 0 ? (time = `(${seconds})`) : (time = '');
    return (
      <>
        <DialogContent className={classes.dialogContent}>
          <TaskAltOutlinedIcon color="primary" className={classes.tick} />
          <Typography variant="h5" className={classes.otptitle}>
            Thank you, an OTP has been sent to this email address.
            <br /> Please insert OTP to verify your email address.
          </Typography>
          <Form>
            <Input {...register('otp')} fullWidth label="OTP" variant="outlined" />
          </Form>
          <Box display={'flex'} justifyContent={'center'} marginTop={'30px'}>
            <PrimaryButton
              size={'large'}
              disabled={seconds > 0}
              variant={'outlined'}
              sx={{ borderRadius: '10px', mr: 2 }}
              onClick={() => onEmailSubmit({ resend: true })}
            >
              {`Resend otp ${time}`}
            </PrimaryButton>
            <PrimaryButton
              size={'large'}
              disabled={loading}
              sx={{
                borderRadius: '10px',
                '&.Mui-disabled': {
                  background: '#CC6323',
                  color: '#fff',
                },
              }}
              onClick={onOTPSubmit}
            >
              {'Submit'}
            </PrimaryButton>
            <Box display={'flex'} mt={'auto'} mb={'auto'}>
              {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
            </Box>
          </Box>
        </DialogContent>
      </>
    );
  };

  const projectsList = () => {
    return (
      <>
        {submitions && submitions.length > 0 ? (
          <>
            <DialogContent className={classes.dialogContent}>
              <Typography
                variant="h5"
                sx={{
                  marginBottom: '30px',
                }}
                className={classes.projectListTitle}
              >
                Please select the application you wish to continue with:
              </Typography>
              {submitions &&
                submitions.map((item, index) => (
                  <ListItem key={index} className={classes.listItem} disablePadding>
                    <ListItemText className={classes.vehicleName} primary={item.vehicle} />
                    <ListItemText primary={moment(item.updatedAt).format('YYYY/MM/DD')} />
                    {selectedSubmition._id == item._id && deleteConfirmation ? (
                      <Grow
                        in={deleteConfirmation && selectedSubmition._id == item._id}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(deleteConfirmation ? { timeout: 1000 } : {})}
                      >
                        <Box display={'flex'} width={'80px'}>
                          <Zoom in={deleteConfirmation}>
                            <IconButton
                              size="large"
                              onClick={() => handleChange()}
                              aria-label="delete"
                            >
                              <CloseIcon color="error" />
                            </IconButton>
                          </Zoom>
                          <Zoom
                            in={deleteConfirmation}
                            style={{
                              transitionDelay: deleteConfirmation ? '100ms' : '0ms',
                            }}
                          >
                            <IconButton
                              size="large"
                              onClick={() => deleteSubmision(item)}
                              aria-label="delete"
                              disabled={loading}
                            >
                              <DoneIcon color="success" />
                            </IconButton>
                          </Zoom>
                        </Box>
                      </Grow>
                    ) : (
                      <Grow
                        in={
                          (!deleteConfirmation && selectedSubmition._id == item._id) ||
                          selectedSubmition._id != item._id
                        }
                        style={{ transformOrigin: '0 0 0' }}
                        {...(deleteConfirmation ? { timeout: 1000 } : {})}
                      >
                        <Box display={'flex'} width={'80px'}>
                          <Checkbox
                            tabIndex={-1}
                            disableRipple
                            checked={selectedSubmition._id == item._id}
                            onChange={() => selectSubmition(item)}
                          />
                          <IconButton
                            disabled={selectedSubmition._id != item._id}
                            onClick={() => handleChange()}
                            edge="end"
                            aria-label="comments"
                            size="large"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </Grow>
                    )}
                  </ListItem>
                ))}
              <Box display={'flex'} justifyContent={'end'}>
                <PrimaryButton
                  size={'large'}
                  color="secondary"
                  className={classes.continueButton}
                  onClick={() => handleBack()}
                >
                  {'Back'}
                </PrimaryButton>
                <PrimaryButton
                  sx={{
                    mt: 'auto',
                    mb: 'auto',
                    height: 'fit-content',
                    '&.Mui-disabled': {
                      background: '#CC6323',
                      color: '#fff',
                    },
                  }}
                  disabled={loading}
                  size={'large'}
                  className={classes.continueButton}
                  onClick={() => continueWithApplication(selectedSubmition)}
                >
                  {'Continue'}
                </PrimaryButton>
                <Box display={'flex'} mt={'auto'} mb={'auto'}>
                  {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
                </Box>
              </Box>
            </DialogContent>
          </>
        ) : (
          <DialogContent>
            <Box
              display={'flex'}
              flexDirection={'column'}
              justifyContent={'center'}
              textAlign={'center'}
              m={'auto'}
            >
              <Typography variant="h4" className={classes.title}>
                You do not have any incompleted applications.
              </Typography>{' '}
              <Typography variant="h5">Would you like to try another email address?</Typography>
              <Input {...register('email')} label="Email" variant="outlined" />
            </Box>
            <DialogActions>
              <PrimaryButton
                size={'large'}
                className={classes.continueButton}
                disabled={loading}
                sx={{
                  borderRadius: '10px',
                  mr: 2,
                  '&.Mui-disabled': {
                    background: '#CC6323',
                    color: '#fff',
                  },
                }}
                onClick={() => onEmailSubmit({ resend: false })}
              >
                {'Submit'}
              </PrimaryButton>
              <PrimaryButton
                size={'large'}
                className={classes.continueButton}
                color="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                {'Close'}
              </PrimaryButton>
              <Box display={'flex'} mt={'auto'} mb={'auto'}>
                {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
              </Box>
            </DialogActions>
          </DialogContent>
        )}
      </>
    );
  };
  return (
    <>
      <Paper sx={{ mt: 2 }} className={classes.textButton} onClick={() => handleOpen()}>
        <Typography variant="h6">Continue existing application</Typography>
      </Paper>
      <Dialog
        fullWidth
        open={(props.open && props.open) || open}
        onClose={handleClose}
        PaperProps={{ classes: { root: classes.dialog } }}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        {' '}
        <IconButton
          size="large"
          aria-label="close"
          onClick={handleClose}
          className={classes.closeButton}
        >
          <CloseIcon fontSize="meduim" />
        </IconButton>
        {verified ? projectsList() : showOtp ? userOTP() : userEmail()}
      </Dialog>
    </>
  );
}
